import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

import {Grid, Box, Typography, SxProps} from '@mui/material';

import {bodyPdf, pdfH1} from './styles';
import {PdfPageBreakWrapper} from './WrapperComponents/PdfPageBreakWrapper';
import {CultureAnalysisPdfContext} from '../../../contexts/CultureAnalysisPdfContext/CultureAnalysisPdfContext';
import {orangeColors, empionOrangeGradient} from '../../../layouts/theme/designSystem';

export const EmployeeRecommendations = () => {
  const {t} = useTranslation('pdfDomain');
  const {data, loading} = useContext(CultureAnalysisPdfContext);

  if (loading || !data) {
    return null;
  }

  const boxStyles: SxProps = {
    padding: '8px 16px',
    backgroundColor: orangeColors[5],
    boxShadow: 'none',
    borderRadius: '8px',
  };

  const employeeRecommendations = data.employeeRecommendations;
  const sortedEmployeeRecommendations = employeeRecommendations?.slice().sort((a, b) => a.length - b.length);
  const hasRecommendations = Boolean(sortedEmployeeRecommendations?.length);

  return (
    <>
      <Grid container>
        <Grid container sx={{background: empionOrangeGradient.dark}} height={'230px'} p={5}>
          <Box width={'560px'}>
            <Typography variant='h1' sx={pdfH1} mb={3}>
              {t('employeeRecommendations.title')}
            </Typography>
            <Typography sx={bodyPdf} mb={1}>
              {t('employeeRecommendations.textBlock')}
            </Typography>
          </Box>
        </Grid>

        <Grid container p={5} justifyContent={'center'} direction={'row'} spacing={2}>
          {hasRecommendations ? (
            sortedEmployeeRecommendations?.map((recommendation, index) => (
              <PdfPageBreakWrapper key={`${index} ${recommendation}`} item xs={12}>
                <Box sx={{...boxStyles, backgroundColor: orangeColors[5], border: `1px solid ${orangeColors[3]}`}}>
                  <Typography sx={bodyPdf}>{recommendation}</Typography>
                </Box>
              </PdfPageBreakWrapper>
            ))
          ) : (
            <Grid item xs={12}>
              <Box
                sx={{
                  ...boxStyles,
                  backgroundColor: orangeColors[5],
                  border: `1px solid ${orangeColors[3]}`,
                  padding: '24px',
                  textAlign: 'center',
                  width: '100%',
                }}
              >
                <Typography sx={bodyPdf}>{t('employeeRecommendations.emptyState')}</Typography>
              </Box>
            </Grid>
          )}
        </Grid>
      </Grid>
    </>
  );
};
